// Helper function to safely get error message following Kent C. Dodds pattern
// https://kentcdodds.com/blog/get-a-catch-block-error-message-with-typescript
export default function getTypeSafeErrorMessage(error: unknown): string {
    if (error instanceof Error) return error.message;
    if (typeof error === 'object' && error !== null) {
        return JSON.stringify(error);
    }
    return String(error);
}
